import {AxiosInstance, AxiosResponse} from "axios";
import {ExperienceEvent} from "@/core/interfaces/experience/ExperienceEvent";
import {Experience} from "@/core/interfaces/experience/Experience";
import {PaginatedData, PaginationRequest} from "@/core/interfaces/api";
import {ExperienceTransaction} from "@/core/interfaces/experience/ExperienceTransaction";

export type ExperienceTransactionApiResponse = PaginatedData<ExperienceTransaction[]> & {
    meta: {
        apodis_coin_ratio: {
            threshold: number;
            reward: number;
        }
    }
};

/**
 * The experience resource.
 * @author Thomas Denneulin <t.denneulin@apodispharma.com>
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Get all experience events.
         *
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async indexEvents(): Promise<ExperienceEvent[]> {
            return client
                .get('/experience/events')
                .then((response: AxiosResponse) => response.data.data);
        },
        /**
         * Get all experience transactions for current authenticated organization.
         *
         * @return {Promise<PaginatedData<ExperienceTransaction[]>>}
         */
        async indexTransactions(request?: PaginationRequest): Promise<ExperienceTransactionApiResponse> {
            return client.get("/experience/transactions", {params: request})
                .then((response: AxiosResponse) => response.data);
        },

        /**
         * Read user organization experience.
         */
        async read(): Promise<Experience> {
            return client.get('/experience')
                .then((response: AxiosResponse) => response.data.data);
        }
    };
}
